import CrudCustom from '../../../libs/custom/CrudCustom';

let KelompokPenghasilan = new CrudCustom('/kelompok-penghasilans');
export default KelompokPenghasilan;
